import React, { useEffect, useState } from "react";
import { db } from "../../../config/firebase";
import { onSnapshot, setDoc, getDoc, doc, serverTimestamp } from "firebase/firestore";

const SelectOrder = ({ selectedOrder, setSelectedValue }) => {
  const [confirm, setConfirm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  
  const handleSelectChange = async (option) => {
 
    setIsLoading(true);
    let c = option;
    const urlParams = new URLSearchParams(window.location.search);
    const currentDomain = urlParams.get("parentUrl");
  

    const stored_var_name=currentDomain+"myData"
    if (c != "choose orderid") {
    
      const storedData = localStorage.getItem(stored_var_name);

 
      if (storedData) {
        const parsedData = JSON.parse(storedData);
       
        const docid = parsedData.key;
        const docRef = doc(db, "Messages", docid);
        const docSnap = await getDoc(docRef);
        var allmessage = [];
      
        if (docSnap.exists) {
          allmessage = docSnap.data().Messages;
          var lastmessage = allmessage[allmessage.length - 1];
          lastmessage.action = JSON.stringify(option);
          lastmessage.OrderID = option.OrderID
          allmessage[allmessage.length - 1] = lastmessage;
        }
        setDoc(
          docRef,
          {
            Messages: allmessage,
            Selected_Order: option,
          last_updated:serverTimestamp(),
            timestamp: Date.now(),
          },
          { merge: true }
        )
          .then((hello) => {
            // const url = "http://127.0.0.1:8080/?docid="+docid+"&shop_id="+"indidiva.com";
            // let url = "https://chat-app-art-w4axif2xma-el.a.run.app/" + docid;
            
            // // const url="https://version-2-llm-371280248581.asia-south1.run.app/"+docid;
            const urlParams = new URLSearchParams(window.location.search);
            const parenturl = urlParams.get('parentUrl')?.trim().toLowerCase();
            let  url="https://whatsappbot.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/?docid="+docid+"&shop_id="+parenturl;
 
            // const allowedUrls = ["test.gamenation", "gamenation.in", "gradcapital", "cottoncandywala.in"];
            // console.log(parenturl)
            // if(parenturl && allowedUrls.includes(parenturl)){
          //  let   url="https://version-2-llm-371280248581.asia-south1.run.app/?docid="+docid+"&shop_id="+parenturl;
            // }
            // const channel = urlParams.get("channel");
            // console.log(channel)
            // if (channel && channel.trim().toLowerCase() === "shopify") {
            //   url = "https://shopify-backend-371280248581.asia-south1.run.app/" + docid;
            // }
            
            fetch(url,{ method: 'GET'})
              .then((hello) => {
                console.log("URL is fetched", hello);
              })
              .catch((err) => {
                console.log("No check", err);
              })
              .finally(() => {
                setIsLoading(true);
              });
          })
          .catch(() => {
            console.log("Problem while setting up doc");
          });
      }
    }
  };
  return (
    <div className="krunk-bg-white krunk-w-full krunk-px-4 krunk-rounded-2xl krunk-py-2 krunk-transform krunk-duration-200 krunk-mt-2">
    <div className="krunk-text-sm krunk-font-semibold krunk-py-1">
      ORDER ID: {selectedOrder.OrderID}
    </div>
  
    <div className="krunk-mt-1 krunk-mb-2 krunk-space-y-2">
      {selectedOrder &&
        selectedOrder?.Items?.map((item, i) => {
          return (
            <div
              key={i}
              className={
                "krunk-border krunk-w-full krunk-flex krunk-items-center krunk-gap-2 krunk-rounded-lg krunk-p-0 "
              }
            >
              <img
                src={item.image_url}
                alt=""
                className="krunk-rounded-md krunk-w-[50px]"
              />
              <div className="">
                <h1 className="krunk-font-semibold krunk-capitalize krunk-px-1">
                  {item.name}
                </h1>
                <p className="krunk-text-secondary krunk-text-sm krunk-text-left  krunk-px-1">
                  ₹{item.price}
                </p>
              </div>
            </div>
          );
        })}
    </div>
  
    <p className="krunk-text-sm krunk-font-semibold">
      TOTAL: &nbsp;₹{selectedOrder?.TotalCost}
    </p>
  
    <div className="krunk-flex krunk-items-center krunk-justify-start krunk-gap-1 krunk-py-1 krunk-text-secondary">
      {/* <img src={orderSuccessImg} alt="" /> */}
      <p className="krunk-text-sm">
        {selectedOrder?.Items?.length} items delivered on &nbsp;
        {selectedOrder?.ShippingDate}
      </p>
    </div>
    <div className="krunk-flex krunk-items-center krunk-gap-2 krunk-justify-between krunk-mt-1">
      <button
        className="krunk-py-2 krunk-px-4 krunk-rounded-2xl krunk-border  krunk-border-primary1 krunk-text-primary1 krunk-w-fit krunk-font-semibold"
        onClick={() => {
          setSelectedValue(null);
        }}
      >
        Go Back
      </button>
      <button
        className={`krunk-py-2 krunk-px-4 krunk-font-semibold krunk-rounded-2xl krunk-border krunk-text-white ${
          !confirm && "krunk-selected-bg"
        } krunk-flex-1 krunk-disabled:bg-gray-400 krunk-disabled:pointer-events-none`}
        onClick={() => {
          handleSelectChange(selectedOrder);
          setConfirm(true);
        }}
        disabled={confirm || isLoading}
      >
        Confirm
      </button>
    </div>
  </div>
  
  );
};

export default SelectOrder;
